import React, { useState } from 'react';
import t from '~t';
import { useDispatch } from 'react-redux';
import { removeAll } from '~data/actions/collections';

import { Error, Alert, Confirm } from '~co/overlay/dialog';
import { Icon, Item, ItemTitle, ItemIcon, ItemLink, Modal, ModalHeader as Header, Preloader } from '~ui';

export default function SettingsProfileReset() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  //t.s() at render — a language switch remounts without re-running the module
  const label = t.s('removeAllData');
  const action = t.s('removeAll');

  const onResetClick = async () => {
    if (!(await Confirm(label + '?', { ok: action }))) return;

    setLoading(true);

    dispatch(
      removeAll(
        () => {
          Alert(t.s('done'));
          setLoading(false);
        },
        (e) => {
          Error(e);
          setLoading(false);
        },
      ),
    );
  };

  return (
    <>
      <Item>
        <ItemIcon>
          <Icon name='trash' />
        </ItemIcon>
        <ItemTitle>{label}</ItemTitle>
        <ItemLink onClick={onResetClick} />
      </Item>

      {loading && (
        <Modal important closable={false}>
          <Header title={action + '…'}>
            <Preloader />
          </Header>
        </Modal>
      )}
    </>
  );
}
